<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">線上點餐管理 / 加料品管理</b-col>
      <b-col>
        <div class="text-right">
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row mt-3">
                  <label class="control-label col-md-2">品號：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.code" placeholder="請輸入品號">
                  </div>
                  <label class="control-label col-md-2">品名：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.name" placeholder="模糊搜尋">
                  </div>
                </div>
                <div class="row mt-3">
                  <label class="control-label col-md-2">品牌：</label>
                  <div class="col-md-3">
                    <select
                      name="queryBrandsCode"
                      class="form-control"
                      v-model="search.queryBrandsCode"
                        @change="querySelectListData()"
                    >
                    <option
                      v-for="x in selectListBrands"
                      v-bind:value="x.Code"
                      :key="x.Code"
                    >{{x.Text}}</option>
                    </select>
                  </div>
                  <label class="control-label col-md-2">POS分類：</label>
                  <div class="col-md-3">
                    <select id="queryAttributesCode" name="queryAttributesCode" class="form-control"
                      v-model="search.queryAttributesCode">
                      <option value=''>全部</option>
                      <option v-for="x in selectListPosType" v-bind:value="x.Code" :key="x.Code">{{x.Name}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <h3></h3>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>項次</th>
                            <th>POS分類</th>
                            <th>品號</th>
                            <th>品名</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td>{{x.attributeName}}</td>
                            <td>{{x.code}}</td>
                            <td>{{x.name}}</td>
                            <td>
                              <button v-if="FunctionPermission > 1 && x.extraQty > 0" v-b-tooltip.hover.top title="編輯" class="btn-circle btn-circle-ptc1" @click="showEdit(x, true)"><span class="fa fa-pencil-alt"></span></button>
                              <button v-if="x.extraQty > 0" v-b-tooltip.hover.top title="明細" class="btn-circle btn-circle-ptc1" @click="showEdit(x, false)"><span class="fa fa-search-plus"></span></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="totalRows" v-model="search.currentPage" :per-page="pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalRows}}筆</label>
                    </div>
                  </div>
                </div>

          </div>
        </div>
      </b-card>

      <!-- 編輯畫面Modal -->
      <b-modal ref="mdEdit" hide-footer size='lg' :title='detailTitle'>
        <b-container fluid>
          <div class="table-responsive">
            <table class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th>品項名稱</th>
                  <th>APP顯示名稱</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in detailItem" :key="x.ID" :id="x.ID">
                  <td>
                    <b-form-checkbox :checked="x.appShow" v-model="x.appShow" :disabled="!isEdit"></b-form-checkbox>
                    <!-- <b-form-checkbox :checked="isSetTop? (isSeted? top_item.ID==x.ID : x.Sticky) : x.Sticky" :disabled="!isSetTop" v-if="x.Status==1&&x.EnabledAt.substring(0,10)<=today" @change="chkTopChange($event, x)"></b-form-checkbox> -->
                  </td>
                  <td>{{x.name}}</td>
                  <td>{{x.appName}}</td>
                </tr>
              </tbody>
            </table>
            <div class='float-right' v-if="isEdit">
              <b-btn class="mt-3" variant='primary' @click='edit(detailItem)'>確認</b-btn>
              <b-btn class="mt-3" variant='secondary' @click='CancelEdit'>取消</b-btn>
            </div>
          </div>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      search: {
        code: '',
        name: '',
        currentPage: 1,
        queryAttributesCode:'',
        queryBrandsCode: "MWD",
      },
      totalRows: 0,
      pageRows: 20,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      editCode: '',
      detailItem: [],
      detailTitle: '',
      isEdit: false,
      API_URL: API_URL,
      FunctionPermission: 0,
      selectListPosType: [], // Pos分類下拉選單
      selectListBrands: [], // 品牌下拉選單
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F30') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }

    this.querySelectListData();
    this.querySelectListBrands();
    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
      this.query()
    } else {
      this.reset()
    }
  },
  methods: {
    querySelectListData () {
      //Pos分類
      axios
        .post(API_URL + "/web/shopping/getallproductAttributes/v1", {
          status: 0,
          brandCode: this.search.queryBrandsCode,
        })
        .then(response => {
          this.selectListPosType = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListPosType = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
        });
    },
    reset () {
      this.search.code = ''
      this.search.name = ''
      this.search.queryAttributesCode = ''
      this.search.currentPage = 1
      this.search.queryBrandsCode = 'MWD'

      this.query()
    },
    btnQuery () {
      this.search.currentPage = 1
      this.query()
    },
    query () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getProductByExtra/v1', {
        code: this.search.code,
        name: this.search.name,
        attributeCode: this.search.queryAttributesCode,
        toPage: this.search.currentPage,
        perPage: this.pageRows,
        brandCode: this.search.queryBrandsCode,
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            // this.search.currentPage = response.data.pageNumber // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageRows * (this.search.currentPage - 1) + 1;
            this.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageRows > response.data.totalRows) ? response.data.totalRows : (this.search.currentPage * this.pageRows) >= response.data.totalRows ? response.data.totalRows : this.search.currentPage * this.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    showEdit (item, isEdit) {
      this.isEdit = isEdit
      var title = ''
      if (this.isEdit) {
        title = '編輯'
        this.editCode = item.code
      }
      this.detailTitle = title + '加料品-' + item.name + ' [' + item.code + ']'
      this.detailItem = JSON.parse(JSON.stringify(item.extra))
      this.$refs.mdEdit.show()
    },
    CancelEdit () {
      this.$refs.mdEdit.hide();
    },
    edit (item) {
      this.$parent.Loading = true
      // 取得id與新的排序
      var arrAll = []
      item.forEach(function (arrItem, Index) {
          arrAll.push({
              id: arrItem.id,
              appShow: arrItem.appShow
          })
      })

      return axios.post(API_URL + '/web/shopping/editProductByExtra/v1', {
        productCode: this.editCode,
        data: arrAll,
      })
        .then((response) => {
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.$refs.mdEdit.hide()
            this.query()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
        })
    },
    editCancel () {
      this.$refs.mdEdit.hide()
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 320px;
  height: 270px;
}
.active {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/extra/List.vue